<template>
    <div></div>
</template>

<script>
import BelowQuickSearch from './BelowQuickSearch.js';
export default BelowQuickSearch;
</script>
